import React from "react";
import {DatePicker, Form, message, Modal} from "antd";
import {GeneratorFilter} from "../../../../filters/Generator";
import {BillToFilter} from "../../../../filters/BillTo";
import {AddWorkOrderService} from "../../quotes/extra/AddWorkOrderServiceForm";
import {WorkOrderGet, WorkOrderPost, WorkOrderUpdate} from "../../../../models/workorder";
import {QuotePost} from "../../../../models/quote";
import {Config} from "../../../../controller/Global";
import {CopyGenerator} from "../../../../controller/Utils";
import Input from "antd/es/input";
import Tooltip from "antd/es/tooltip";
import Button from "antd/es/button";
import {HotSheetFilter} from "../../../../filters/HotSheetFilter";
import {HotSheetList} from "../../../../models/hotsheet";
import {ServiceGet} from "../../../../models/service";

const FormItem = Form.Item;
const moment = require('moment');
const _ = require('lodash');

class AddUpdateWorkOrderForm extends React.Component {
  state = {
    confirmLoading: false,
    is_hotsheet: false,
    hotsheet_data: {}
  };

  handlePopupAfterAddUpdate = () => {
    this.props.fetch();
    this.props.setModelVisible()
  };
  handleUpdate = (id) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        values['date'] = moment(values['date']).format('YYYY-MM-DD');
        WorkOrderUpdate(id, values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.name }
            });
            message.success('Work Order updated successfully');
            form.resetFields();
            this.handlePopupAfterAddUpdate()
          });
      }
    });
  };
  handleCreate = (e) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        values['type'] = Config.constant.quote_type.workorder;
        values['date'] = moment(values['date']).format('YYYY-MM-DD');
        QuotePost(values)   // Save Quote as well before save work order
          .then(response => {
            values['quote'] = response.id;
            WorkOrderPost(values)
              .then(response => {
                this.setState({
                  visible: false,
                  value: { key: response.id, label: response.name },
                  hotsheet_data: {}
                });
                message.success('Work Order created successfully');
                form.resetFields();
                this.handlePopupAfterAddUpdate()
              });
          });
      }
    });
  };


  onRowUpdateClick = (id) => {
    const form = this.props.form;
    WorkOrderGet(id, {depth: 4})
      .then(response => {
        form.setFieldsValue({
          po: response.data.po,
          date: moment(response.data.date)
        })
        this.generator.handleChange({
          key: response.data.generator.id,
          label: `${response.data.generator.company_name} ${response.data.generator.account_number}`
        });
        this.bill_to.handleChange({
          key: response.data.bill_to.id,
          label: `${response.data.bill_to.company_name} ${response.data.bill_to.account_number}`
        });
        response.data.service.forEach(service => {
          this.service.handleChange(service)
        })
      });
  };

  handleGeneratorChange = (value, bill_to=null) => {
    if(bill_to)
      this.bill_to.handleChange(bill_to);
    const hotsheet_data = this.state.hotsheet_data;
    hotsheet_data['generator__id'] = value;
    this.setState({hotsheet_data})
  };
  handleHotSheetChoose = (value) => {
    ServiceGet(value[0])
      .then(response => {
         const waste_code = _.get(response, 'data.waste_data.0.waste_stream.code');
        const hotsheet_data = this.state.hotsheet_data;
        hotsheet_data['service__waste_stream__waste_stream__code'] = waste_code;
        this.setState({hotsheet_data});
        HotSheetList({...hotsheet_data})
          .then(response => {
            this.setState({is_hotsheet: Boolean(response.data.results.length)})
            this.hotsheet_id.fetchHotSheet()
          })
      })
  };
  getFieldValue = (field) => {
    return this.props.form.getFieldValue(field)
  }

  makeCopyGenerator = () => {
    CopyGenerator(this)
  }

  componentDidUpdate(prevProps) {
    const { visible, moderated } = this.props;
    if (moderated && visible && (moderated !== prevProps.moderated || visible !== prevProps.visible))
      this.onRowUpdateClick(moderated)
  }
  render() {
    const {getFieldDecorator} = this.props.form;
    const {fields, is_hotsheet, hotsheet_data} = this.state;
    const {moderated, visible} = this.props;
    return (
      <Modal style={{top:0,height:"100%"}} title={moderated ? "Update Work Order" : "Create Work Order"} className="full-size-modal create-quote-btn"
        visible={visible} okText={moderated ? "Update Work Order" : "Create Work Order"}
        onOk={moderated ? () => this.handleUpdate(moderated) : this.handleCreate}
        onCancel={() => this.props.setModelVisible()} width="95%" destroyOnClose={true}>
        <div className="col-xs-12 paddingZ add-item-inner floating-form">
          <Form>
            <div className="row full-floating-inputs">
              <div className="col-sm-6 col-12">
                <div className="floating-label">
                  <FormItem label="Date">
                    {getFieldDecorator('date', {
                      rules: [{ required: true, message: 'Please select date' }],
                      initialValue: moment()
                    })(<DatePicker/>)}
                  </FormItem>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="floating-label">
                  <FormItem label="PO">
                    {getFieldDecorator('po', {
                    })(<Input placeholder="Enter PO" /> )}
                  </FormItem>
                </div>
              </div>
              <div className="col-sm-6 col-12 pos-relative">
                <div className="floating-label">
                  <FormItem label="Generator">
                    {getFieldDecorator('generator', {
                      rules: [{ required: true, message: 'Please select generator' }],
                    })(<GeneratorFilter onChange={this.handleGeneratorChange} onRef={ref => (this.generator = ref)} {...fields} />)}
                  </FormItem>
                </div>
                <div className="copy-data-gene">
                  <Tooltip placement="top" title="Copy Generator to Bill To">
                    <Button onClick={this.makeCopyGenerator}><i className="fa fa-angle-right" /></Button>
                  </Tooltip>
                 </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="floating-label">
                  <FormItem label="Bill to">
                    {getFieldDecorator('bill_to', {
                      rules: [{ required: true, message: 'Please select bill to' }],
                    })(<BillToFilter onRef={ref => (this.bill_to = ref)} {...fields} />)}
                  </FormItem>
                </div>
              </div>
              <div className={"col-sm-6 col-12 pos-relative " + (is_hotsheet ? ' ' : 'displaynone')}>
                <div className="floating-label">
                  <FormItem label="Choose HotSheet">
                    {getFieldDecorator('hotsheet_id', {
                    })(<HotSheetFilter hotsheet_data={hotsheet_data}  onRef={ref => (this.hotsheet_id = ref)} {...fields} />)}
                  </FormItem>
                </div>
              </div>
              <div className="floating-Form col-12">
                <div className="col-12 dynamic-area">
                  <div className="field-row">
                    <FormItem>
                      {getFieldDecorator('service', {
                        rules: [{ required: true, message: 'Please add services' }],
                      })(<AddWorkOrderService onChange={this.handleHotSheetChoose} onRef={ref => (this.service = ref)}  {...fields} />)}
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    )
  }
}

export const AddUpdateWorkOrder = Form.create()(AddUpdateWorkOrderForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/popups/AddUpdateWorkOrder.jsx